import React, { useMemo, useRef } from 'react';

import styled from 'styled-components';

import PartnerFeedbackSummary from '@components/partners/PartnerFeedbackSummary';
import PartnerReviewList from '@components/partners/PartnerReviewList';

import { FeedbackSummaryDto, Partner } from '@customTypes/Partner';
import { Services } from '@customTypes/Service';

interface Props {
  partner: Partner;
  services: Services;
  feedbackSummary: FeedbackSummaryDto;
}

const Wrapper = styled.div`
  position: relative;
  h5 {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    font-size: 22px;
    @media (min-width: 992px) {
      font-size: 26px;
    }
    div.count {
      margin-left: 10px;
      color: #055cf5;
      font-size: 20px;
      transform: translateY(1px);
    }
  }
  .summary {
    background-color: #f3f4f8;
  }
`;

const PartnerReview: React.FC<Props> = (props) => {
  const wrapperRef = useRef<HTMLElement | null>(null);
  const { partner, services, feedbackSummary } = props;

  const reviewCounts = useMemo(() => {
    return Object.values(feedbackSummary.scores).reduce((acc, cur) => acc + cur, 0);
  }, [feedbackSummary]);

  return (
    <Wrapper>
      <h5>
        <div>파트너 서비스의 전체 후기</div>
        <div className="count">{reviewCounts}</div>
      </h5>
      <PartnerFeedbackSummary
        reviewCount={partner.review_count}
        reviewScores={feedbackSummary.scores}
        reviewAvg={feedbackSummary.avg}
      />
      <div ref={(ref) => (wrapperRef.current = ref)} style={{ position: 'absolute', top: 210 }} />
      <PartnerReviewList
        onTop={() => setTimeout(() => wrapperRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)}
        partner={partner}
        reviewCount={partner.review_count}
        services={services}
      />
    </Wrapper>
  );
};

export default PartnerReview;
